// src/App.js
import { CssBaseline, ThemeProvider } from '@mui/material';
import React, { useEffect, useState } from 'react';
//import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useRoutes } from 'react-router-dom';


import RTL from './layouts/full-layout/customizer/RTL';
import ThemeSettings from './layouts/full-layout/customizer/ThemeSettings';
import 'react-perfect-scrollbar/dist/css/styles.css';

import Router from './routes/Router';
import { UserProvider } from './context/UserContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import { ConfirmProvider } from './components/common/ConfirmDialog';
import MaintenancePage from './components/common/MaintenancePage';
import { onMaintenance } from './api/apiClient';
import { MissingScopeHandler } from './components/integrations/MissingScopeHandler';
import { PaywallSnackbarHandler } from './components/common/PaywallSnackbarHandler';

function App() {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.CustomizerReducer);

  useEffect(() => {
    onMaintenance(() => setIsMaintenance(true));
  }, []);

  if (isMaintenance) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <MaintenancePage />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={customizer.activeDir}>
        <ErrorBoundary>
          <ConfirmProvider>
            <UserProvider>
              <CssBaseline />
              <MissingScopeHandler />
              <PaywallSnackbarHandler />
              {routing}
            </UserProvider>
          </ConfirmProvider>
        </ErrorBoundary>
      </RTL>
    </ThemeProvider>
  );
}

export default App;
